angular.module('bribac.services.permissions', [])
    .factory('permissions', function (
        ROLES,
        PERMISSION,
        state
    ) {

        var permissions = {

            getPermissionsForRole: function (role) {
                switch (role) {
                    case ROLES.SUPER_ADMIN:
                        return [
                            PERMISSION.CREATE_EDIT,
                            PERMISSION.MANAGE_IBAC,
                            PERMISSION.MANAGE_ORGANIZATION,
                            PERMISSION.DEACTIVATE_AGENT,
                            PERMISSION.MANAGE_INVOICE,
                            PERMISSION.DELETE_IDENTITY
                        ]

                    case ROLES.ADMIN:
                        return [
                            PERMISSION.CREATE_EDIT,
                            PERMISSION.MANAGE_IBAC,
                            PERMISSION.DEACTIVATE_AGENT,
                            PERMISSION.DELETE_IDENTITY
                        ]

                    case ROLES.GROUP_ADMIN:
                        return [
                            PERMISSION.CREATE_EDIT
                        ]

                    default:
                        return []
                }
            },

            canManageOrganizations: function() {
                return this.checkPermission(PERMISSION.MANAGE_ORGANIZATION)
            },

            canManageIbacs: function() {
                return this.checkPermission(PERMISSION.MANAGE_IBAC)
            },

            canManageInvoice: function() {
                return this.checkPermission(PERMISSION.MANAGE_INVOICE)
            },

            canDeactivateAgent: function() {
                return this.checkPermission(PERMISSION.DEACTIVATE_AGENT)
            },

            canDeleteIdentity: function() {
                return this.checkPermission(PERMISSION.DELETE_IDENTITY)
            },

            checkPermission: function(permission) {
                // The case when user is logged out
                if ((!state || Object.keys(state).length === 0)) {
                    return false
                }
                return state.currentAgent.permissions.indexOf(permission) > -1
            },

            hasRole: function(role) {
                return state.currentAgent && state.currentAgent.roles.indexOf(role) > -1
            },
        }

        return permissions
    });